import type { Customer } from "./customer";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isCustomer = (customer: any): customer is Customer => {
    if (!customer) return false;
    // console.log(customerZodSchema);
    return (customer as Customer)?._type === "CUSTOMER";
    // todo! fix to use below when https://github.com/colinhacks/zod/issues/1193 is fixed somehow
    // todo! or when we have
    // customerZodSchema?.safeParse(customer)?.success;
};

export { isCustomer };
